import { FC } from 'react';
import XUIModal, { XUIModalHeader, XUIModalBody, XUIModalFooter } from '@xero/xui/react/modal';
import XUIButton from '@xero/xui/react/button';

export interface IConnectModalProps {
    cancelButtonText: string;
    close: () => void;
    confirmButtonText: string;
    confirmButtonAction: () => void;
    disableConfirmButton?: boolean;
    isLoading: boolean;
    show: boolean;
    title: string;
}

const ConnectModal: FC<IConnectModalProps> = (props) => {
    const { cancelButtonText, confirmButtonText, confirmButtonAction, disableConfirmButton, isLoading, show, title } =
        props;

    return (
        <XUIModal isOpen={show} onClose={props.close} closeButtonLabel='Close'>
            <XUIModalHeader>{title}</XUIModalHeader>
            <XUIModalBody>{props.children}</XUIModalBody>
            <XUIModalFooter className='xui-actions xui-actions-layout xui-padding-large'>
                <XUIButton onClick={props.close} qaHook='connect-modal-cancel' variant='standard'>
                    {cancelButtonText}
                </XUIButton>
                <XUIButton
                    className='xui-actions--primary'
                    onClick={confirmButtonAction}
                    isDisabled={disableConfirmButton}
                    isLoading={isLoading}
                    loadingAriaLabel='Loading'
                    qaHook='connect-modal-connect'
                    variant='main'
                >
                    {confirmButtonText}
                </XUIButton>
            </XUIModalFooter>
        </XUIModal>
    );
};

export default ConnectModal;
